export const LAB_ITEMS = [
  {
    id: "aiticket",
    url: "http://eepurl.com/i-emnQ",
    title: "AI Ticket Writer",
    description:
      "Transform messy ticket descriptions into properly structured tickets with AI-powered suggestions for labels, assignees, and requirements.",
    ogImage: "/assets/labs/aiticket.png",
    color: "teal" as const,
  },
  {
    id: "bandwidth",
    url: "http://eepurl.com/jhuBP2",
    title: "Bandwidth",
    description: "Capacity planning made simple with natural language input.",
    ogImage: "/assets/labs/bandwidth.gif",
    color: "blue" as const,
  },
  {
    id: "doccrusher",
    url: "http://eepurl.com/jimu2A",
    title: "DocCrusher",
    description:
      "Upload PDF, DOCX, PPTX, PNG, or JPG files and get both human-readable summaries and hyper-efficient LLM format. Watch your 2MB documents become 2KB with all context intact.",
    ogImage: "/assets/labs/doccrusher.gif",
    color: "yellow" as const,
  },
  {
    id: "launch-protocol",
    url: "https://launchprotocol.twsp.app/",
    title: "Launch Protocol",
    description:
      'Navigate through "Validation Valley" as Explorer, a hopeful founder on a strange new world. Experience the journey from Prototype to Full Product through interactive gameplay.',
    ogImage: "/assets/labs/launch-protocol.gif",
    color: "pink" as const,
  },
  {
    id: "moodboarder",
    url: "https://moodboarder.twsp.app/",
    title: "Moodboarder",
    description:
      "Get to actual design conversations faster. Rate curated websites, tell us what you love (or don't love) about colors, fonts, layout, and more.",
    ogImage: "/assets/labs/moodboarder.gif",
    color: "peach" as const,
  },
  {
    id: "surprisebot",
    url: "https://surprisebot.twsp.app/",
    title: "SurpriseBot",
    description:
      "SurpriseBot can drop a fun, random prompt in Slack right when you least expect it. Team bonding without the awkward Zoom breakout rooms.",
    ogImage: "/assets/labs/surprisebot.gif",
    color: "peach" as const,
  },
  {
    id: "wizardwizard",
    url: "http://eepurl.com/i_pS_g",
    title: "Wizard Wizard",
    description:
      "Type what you need in plain human language. Watch as our AI assistant translates your words into structured form data. Save hours of mind-numbing checkbox clicking.",
    ogImage: "/assets/labs/wizardwizard.gif",
    color: "teal" as const,
  },
  {
    id: "wrapped",
    title: "Township Wrapped",
    description: "Our year in review, Spotify-style",
    url: "https://wrapped.township.agency/",
    ogImage: "https://wrapped.township.agency/og.png",
    color: "teal" as const,
  },
  {
    id: "resolution",
    url: "https://www.2022resolution.com/",
    title: "Resolution Generator",
    description: `A fun way to generate your New Year's resolution with a twist`,
    ogImage: "https://www.2022resolution.com/ts-og.jpg",
    color: "pink" as const,
  },
  {
    id: "holidai",
    url: "https://holidai.township.agency/",
    title: "HolidAI",
    description: "A Township holiday card experiment with AI",
    ogImage: "https://holidai.township.agency/images/og.png",
    color: "peach" as const,
  },
] as const;

/** Holiday Cards section on `/labs` — below highlights; uses `LabCard` `variant="compact"`. */
export const LAB_HOLIDAY_SEND = [
  {
    id: "resolution",
    url: "https://www.2022resolution.com/",
    title: "Resolution Generator",
    description: `A fun way to generate your New Year's resolution with a twist`,
    ogImage: "https://www.2022resolution.com/ts-og.jpg",
    color: "pink" as const,
  },
  {
    id: "wrapped",
    url: "https://wrapped.township.agency/",
    title: "Township Wrapped",
    description: "Our year in review, Spotify-style",
    ogImage: "https://wrapped.township.agency/og.png",
    color: "teal" as const,
  },
  {
    id: "holidai",
    url: "https://holidai.township.agency/",
    title: "HolidAI",
    description: "A Township holiday card experiment with AI",
    ogImage: "https://holidai.township.agency/images/og.png",
    color: "peach" as const,
  },
  {
    id: "chill-factor",
    url: "https://chillfactor.twsp.app/",
    title: "Chill Factor",
    description:
      "Winter survival dashboard from the holiday card drop, plus newsletter experiments and links.",
    ogImage: "/assets/labs/chill-factor.png",
    color: "blue" as const,
  },
] as const;

const launchProtocolBlurb =
  LAB_ITEMS.find((i) => i.id === "launch-protocol")?.description ??
  "Navigate from prototype to shipped product through narrative gameplay.";

/** Longer lab stories: mostly newsletter issues, plus tools and OSS published elsewhere (e.g. Teal). */
export const LAB_HIGHLIGHT_ITEMS = [
  {
    id: "ssmol",
    url: "https://eepurl.com/jndiqc",
    title: "A Small Solar Model of Language (SSMoL)",
    description: "A deliberately small language surface, powered by the sun.",
    ogImage: "/assets/labs/solarLLM.png",
    color: "teal" as const,
  },
  {
    id: "chief",
    url: "https://eepurl.com/jqi9AI",
    title: "Chief",
    description:
      "How we think about leadership-shaped tooling and delegation in the lab.",
    ogImage: "/assets/labs/chief.png",
    color: "yellow" as const,
  },
  {
    id: "solemate-3d",
    url: "https://eepurl.com/jrrnO2",
    title: "SoleMate3D",
    description:
      "A 3D-forward take on comfort, fit, and product storytelling from the newsletter.",
    ogImage: "/assets/labs/solemate3d.gif",
    color: "peach" as const,
  },
  {
    id: "notion-to-book",
    url: "https://eepurl.com/jycWs6",
    title: "Notion to Book",
    description:
      "Practical lessons from building products with (and for) AI. We Built a Thing distilled into Just Enough AI, our physical-digital book.",
    ogImage: "/book/book-og.png",
    color: "blue" as const,
  },
  {
    id: "agent-door",
    url: "https://eepurl.com/jzo-aE",
    title: "The Agent Door",
    description:
      "Gates, permissions, and how we introduce agents into real internal stacks.",
    ogImage: "/assets/labs/agentdoor.png",
    color: "pink" as const,
  },
  {
    id: "solemate",
    url: "https://eepurl.com/jmd_rA",
    title: "SoleMate",
    description:
      "Comfort, data, and narrative. Newsletter deep dive on an earlier SoleMate chapter.",
    ogImage: "/assets/labs/solemate-store.gif",
    color: "yellow" as const,
  },
  {
    id: "woolf",
    url: "https://eepurl.com/jlix02",
    title: "Woolf",
    description:
      "A writing-first interface experiment we shipped as a lab story.",
    ogImage: "/assets/labs/woolf.gif",
    color: "teal" as const,
  },
  {
    id: "launch-protocol-newsletter",
    url: "https://eepurl.com/jh0Wl6",
    title: "Launch Protocol",
    description: launchProtocolBlurb,
    ogImage: "/assets/labs/launch-protocol.gif",
    color: "pink" as const,
  },
  {
    id: "coach-2",
    url: "https://eepurl.com/ji3b4g",
    title: "Coach! 2.0",
    description:
      "Highlight any text and get a Coach Taylor-style speech about your specific digital nightmare. Browser extension from We Built a Thing #23.",
    ogImage: "/assets/labs/coach.gif",
    color: "peach" as const,
  },
  {
    id: "doccrusher-newsletter",
    url: "https://eepurl.com/jimu2A",
    title: "DocCrusher",
    description:
      "Upload PDF, DOCX, PPTX, PNG, or JPG and get human-readable summaries plus hyper-efficient LLM format. ",
    ogImage: "/assets/labs/doccrusher.gif",
    color: "yellow" as const,
  },
  {
    id: "wbatt-29-all-the-prompts",
    url: "https://eepurl.com/jlMiZg",
    title: "All the Prompts You’ve Loved Before Are Waiting Here",
    description:
      "A prompt testing platform: compare models with cost and token visibility so your best prompts do not vanish into chat history.",
    ogImage: "/assets/labs/prompt.gif",
    color: "blue" as const,
  },
  {
    id: "teal",
    url: "https://github.com/township-agency/ex_teal",
    title: "Teal",
    description:
      "Teal is an open-source admin dashboard built in Elixir and Phoenix. It powers many of our client applications.",
    ogImage: "/assets/labs/teal.png",
    color: "teal" as const,
  },
] as const;
